export const ReplaySection = (props) => {
    const headline = props.headline || "Slow-motion instant replays";
    const subHeading = props.subHeading;
    const image = props.image;
    return (<section className="atf-section-padding" style={{background: 'url(./assets/img/smokebg_white_light_compressed.jpg)', backgroundRepeat: 'no-repeat'}}>
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-8 col-12 text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "15px 0 20px 0"  }}>{subHeading}</p>
                          </div>
                      </div>
                      <div className="col-lg-4 col-12 text-center">
                        <img src={image} alt={headline}/>
                      </div>
                  </div>
              </div>
          </section> 
    
    );
}

export default ReplaySection;